import { useRef, useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { resolveImg, formatApiError } from "../lib/api";

export default function ImageUploader({ label, value = [], onChange, testid }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (files) => {
    if (!files?.length) return;
    setUploading(true);
    try {
      const uploaded = [];
      for (const file of Array.from(files)) {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        uploaded.push(data.url);
      }
      onChange([...(value || []), ...uploaded]);
      toast.success(`${uploaded.length} file caricati`);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Upload fallito");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));

  return (
    <div>
      <label className="text-xs uppercase tracking-wide text-fir-deep/60">{label}</label>
      <div className="grid grid-cols-4 gap-2 mt-1.5">
        {(value || []).map((url, i) => (
          <div key={i} className="relative group aspect-square rounded-xl overflow-hidden border border-stone">
            <img src={resolveImg(url)} alt="" className="h-full w-full object-cover" />
            <button type="button" data-testid={`${testid}-remove`} onClick={() => remove(i)}
              className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity">
              <X size={12} />
            </button>
          </div>
        ))}
        <button type="button" data-testid={testid} onClick={() => inputRef.current?.click()} disabled={uploading}
          className="aspect-square rounded-xl border-2 border-dashed border-wood/50 flex flex-col items-center justify-center text-fir-deep/60 hover:border-gold hover:text-gold transition-colors">
          {uploading ? <Loader2 className="animate-spin" size={20} /> : <><Upload size={20} /><span className="text-xs mt-1">Carica</span></>}
        </button>
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple className="hidden"
        onChange={(e) => handleFiles(e.target.files)} />
    </div>
  );
}
